import jQuery from 'jquery';
import fastclick from 'fastclick';
import 'promise-polyfill/src/polyfill';

import './helpers/_iePolyfills';

import './plugins/modernizr-min';
import './plugins/js.cookie.js';

import './_vhUnitFix';
import './_videoEmbed';
import './_scrollToElement';
import './_objectfitFallback';
import './_backgroundVideo';
import './_externalLinks';
import './_csrf';
import './_formieForms';
import InitChat from './_chat';

global.$ = global.jQuery = jQuery;
global.InitChat = InitChat;


$(document).on('change', '.locale-picker select', function (event) {
  const target = event.target;
  if (target.value) {
    window.location = target.value;
  }
});

if (window.location.search != '') {

  const search = window.location.search.substring(1);
  if (search.indexOf('=') !== -1) {
    const urlParameters = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

    $.each(urlParameters, function (fieldName, fieldValue) {
      const foundInputs = $('[name="fields[' + fieldName + ']"]');
      if (foundInputs.length > 0) {
        foundInputs.each(function (key, value) {
          const input = $(this);
          const inputType = input.attr('type');

          if (inputType == 'radio' || inputType == 'checkbox') {
            if (input.val() == fieldValue) {
              input.attr('checked', 'checked');
            }
          } else {
            input.val(fieldValue);
          }
        });
      }
    });
  }
}
